module.exports = __webpack_public_path__ + "static/media/i_pad_pro.278df9e3.png";